<template>
  <div class="article-item">
    <meta name="referrer" content="no-referrer" />
    <van-cell>
      <!-- 标题部分 -->
      <div slot="title" class="title van-multi-ellipsis--l2">{{article.homeName}}</div>
      <!-- 具体描述部分 -->
      <div slot="label" class="label">
        <div class="label-info-wrap">
          <span>{{article.homeNr}}</span>
          <!-- <span>3</span>
          <span>4</span> -->
        </div>
      </div>
      <!-- 单元格右边的图片 -->
      <van-image
        slot="default"
        class="right-cover"
        fit="cover"
        src="../assets/cha.png"
      />
    </van-cell>
  </div>
</template>

<script>
export default {
  name: 'ArticleItem',
  props: {
    article: {
      type: Object,
      // required: true,
      default:{}
    }
  }
}
</script>

<style lang="less" scoped>
.article-item {
  .title {
    font-size: 32px;
    color: #3a3a3a;
  }

  .van-cell__value {
    flex: unset;
    width: 232px;
    height: 146px;
    padding-left: 25px;
  }

  .right-cover {
    width: 232px;
    height: 146px;
  }

  .label-info-wrap span {
    font-size: 22px;
    color: #b4b4b4;
    margin-right: 25px;
  }

  .cover-wrap {
    display: flex;
    padding: 30px 0;
    .cover-item {
      flex: 1;
      height: 146px;
      &:not(:last-child) {
        padding-right: 4px;
      }
      .cover-item-img {
        width: 100%;
        height: 146px;
      }
    }
  }
}
</style>
